import { Controller, useFormContext } from "react-hook-form";
import { useSalesareaCtx } from "../../modernTS/salesarea/SalesareaContext";
import { Box, FormLabel, IconButton, Typography } from "@mui/material";
import React from "react";
import Menu from "../../modernTS/JUI/Menus/Menu";
import usePickMenu, { NO_MENU_SELECTED } from "../../modernTS/JUI/Menus/usePickMenu";
import { Products } from "../../modernTS/JUI/Products/Products";
import useAddProducts, { NO_PRODUCT_SELECTED } from "../../modernTS/JUI/Products/useAddProducts";
import { Product } from "../../modernTS/JUI/Products/Product";
import { Delete } from "@mui/icons-material";
import { UpsellTriggersData } from "../VariantUpsell/UpsellAddTriggersStep";
import { Menus } from "../../modernTS/JUI/Menus/Menus";

export default function UpsellTriggers({
  onChange,
}: {
  onChange?: (triggers: UpsellTriggersData["triggers"]) => void;
}) {
  const { control } = useFormContext<UpsellTriggersData>();

  const { menuSalesareaId } = useSalesareaCtx();

  const openMenuSelector = usePickMenu({ allowMultiple: true, menuSalesareaId });
  const openProductSelector = useAddProducts({ allowMultiple: true, menuSalesareaId });
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: "120px 1fr", gap: 2, alignItems: "center" }}>
      <Controller
        control={control}
        name={"triggers"}
        render={({ field, fieldState: { invalid, error } }) => {
          const change = function (triggers: UpsellTriggersData["triggers"]) {
            field.onChange(triggers);
            onChange?.(triggers);
          };
          return (
            <>
              <FormLabel sx={{ alignSelf: "baseline" }}>Trigger products</FormLabel>
              <Products
                allowAdd
                onAdd={async () => {
                  const products = await openProductSelector();
                  if (products !== NO_PRODUCT_SELECTED) {
                    change({
                      products: [...field.value.products, ...products],
                      menus: [...field.value.menus],
                    });
                  }
                }}
                products={field.value.products}
              >
                {(p, pIdx) => (
                  <Product
                    key={p.id}
                    product={p}
                    rightAction={
                      <IconButton
                        onClick={() => {
                          change({
                            products: field.value.products.filter((_, idx) => idx !== pIdx),
                            menus: [...field.value.menus],
                          });
                        }}
                      >
                        <Delete fontSize={"small"} />
                      </IconButton>
                    }
                  />
                )}
              </Products>

              <FormLabel sx={{ alignSelf: "baseline" }}>Trigger menus</FormLabel>
              <Menus
                allowAdd
                menus={field.value.menus}
                onAdd={async () => {
                  const menus = await openMenuSelector();
                  if (menus !== NO_MENU_SELECTED) {
                    change({
                      products: [...field.value.products],
                      menus: [...field.value.menus, ...menus],
                    });
                  }
                }}
              >
                {(m, mIdx) => {
                  return (
                    <Menu
                      menu={m}
                      rightAction={
                        <IconButton
                          onClick={() => {
                            change({
                              menus: field.value.menus.filter((_, idx) => idx !== mIdx),
                              products: [...field.value.products],
                            });
                          }}
                        >
                          <Delete fontSize={"small"} />
                        </IconButton>
                      }
                    />
                  );
                }}
              </Menus>
              {invalid ? (
                <Typography color={"error"} sx={{ gridColumn: "span 2" }}>
                  {error?.message}
                </Typography>
              ) : null}
            </>
          );
        }}
        rules={{
          validate: ({ menus, products }) => {
            if (products.length === 0 && menus.length === 0) {
              return "Need to choose at least one product or one menu";
            }
            return true;
          },
        }}
      />
    </Box>
  );
}
